import Vue from 'vue'
import Element from 'element-ui'
import draggable from 'vuedraggable'

import 'src/utils/polyfill'
import store from 'src/store/dev'
import router from 'src/router/dev'
import BaseComponents from 'components'
import DevComponents from 'components/dev'

import 'normalize.css'
import 'console-theme/lib/index.css'
import 'src/common/less/base.less'
import 'src/common/less/dev.less'
import 'src/common/less/iconfont.less'

import App from './App'
import { bus } from '../../utils/event'
import { bindNativeEvent, bindPageShow } from '../../utils/nativeEvent'

Vue.use(Element)
Vue.use(BaseComponents)
Vue.use(DevComponents)

Vue.component('draggable', draggable)

store.watch(
    state => state.isLogin,
    isLogin => {
        if (isLogin) {
            router.replace({ name: 'product' })
        } else {
            router.replace({ name: 'login' })
        }
    }
)

router.beforeEach((to, from, next) => {
    if (
        !store.state.isLogin
        && to.matched.some(record => record.meta && record.meta.isCustom)
    ) {
        next()
    } else if (store.state.isLogin) {
        // 必须登录页面
        if (to.name === 'login') {
            next({ name: 'product' })
        } else {
            next()
        }
    } else if (to.name !== 'login') {
        next({ name: 'login' })
    }
})

bus.$on('404', () => router.replace('/404.html'))
bus.$on('403', () => router.replace('/403.html'))

// eslint-disable--nextline
const vm = new Vue({
    store,
    router,
    render: h => h(App)
})

bus.$on('-200', () => {
    if (vm.$route.name !== 'profile' || !vm.$route.query.forceChangePwd) {
        router.replace({ name: 'profile', query: { forceChangePwd: true } })
    }
})

vm.$mount('#app')

//绑定一些原生js事件
bindNativeEvent()
bindPageShow(store)
